import type { FC } from "react";
import { translate } from "app/filters/i18nFilter";
import { openHooksModalV5 } from "app/services/ModalService";
import { isAvailable } from "app/common/services/pageClaims";
import { swSettings } from "app/common/services/swSettings";
import { MARKET_ANALYSIS_HOOK } from "./consts";
import { StyledButton } from "./StyledComponents";
import type { INavigateToPlayers } from "../custom-industry-modal/services/navigateToPlayers";
import { navigateToPlayers } from "../custom-industry-modal/services/navigateToPlayers";
import { getCountryFromFC } from "../custom-industry-modal/utils/utils";

interface IViewRelatedIndustryBtn {
    isDisabled?: boolean;
    customIndustryId: string;
    trackingEvent?: () => void;
}

const ViewRelatedIndustryBtn: FC<IViewRelatedIndustryBtn> = ({ isDisabled, customIndustryId, trackingEvent }) => {
    const isHooked = !isAvailable(swSettings.components["WebMarketResearchOverviewHome"]);
    const buttonType = isHooked ? "trial" : "flat";
    const iconName = isHooked ? "sparkles-gray" : "arrow-right";
    const iconPlacement = isHooked ? "left" : "right";

    const getHookModalType = () => {
        if (isHooked) {
            return MARKET_ANALYSIS_HOOK;
        }
    };

    const onBtnClick = () => {
        if (isDisabled) {
            return;
        }

        const hookModalType = getHookModalType();
        if (hookModalType) {
            openHooksModalV5(hookModalType);
        } else {
            trackingEvent && trackingEvent();
            const country = getCountryFromFC();
            const navigateParams: INavigateToPlayers = { marketId: customIndustryId };
            if (country) {
                navigateParams.country = country;
            }
            navigateToPlayers(navigateParams);
        }
    };

    return (
        <div data-automation="ViewRelatedIndustryBtn">
            <StyledButton
                onClick={isDisabled ? undefined : onBtnClick}
                type={buttonType}
                isDisabled={isDisabled}
                iconName={iconName}
                placement={iconPlacement}
            >
                {translate("segments.page.comparison.view.related.industry.btn.text")}
            </StyledButton>
        </div>
    );
};

export default ViewRelatedIndustryBtn;
